import { combineReducers } from 'redux';

import login from './login';
import user from './user';

import bill from './bill';
import credit from './bill/credit';
// import partRefund from './bill/partRefund';
import partSettle from './bill/partSettle';
import preSettle from './bill/preSettle';
import print from './bill/print';
import reverse from './bill/reverse';
import revSettle from './bill/revSettle';
// import reverse from './bill/reverse';
import settle from './bill/settle';
import transfer from './bill/transfer';
import refund from './bill/refund';

import computer from './computer';
import card from './card';
import goods from './goods';
import inventory from './inventory';
import goodsManagement from './goodsManagement';
import record from './record';
import stock from './stock';
import storeStorage from './storeStorage';
import goodsStock from './goodsStock';
import peripheral from './peripheral';
import peripheralManagement from './peripheralManagement';
import peripheralStock from './peripheralStock';

import meituanDirect from './meituanDirect';
import ctripDirect from './ctripDirect';
import changePriceApprove from './changePriceApprove';
import dyDirect from './dyDirect';

import storeInfo from './storeInfo';
import roomType from './roomType';

import staff from './staff';
import order from './order';
import realtimeState from './roomState/realtime';
import futureState from './roomState/future';
import guest from './guest';
import transaction from './transaction';
import channel from './channel';
import price from './price';
import promotion from './promotion';
import priceCalendar from './priceCalendar';

import handover from './handover';
import reports from './reports';
import otaBill from './otaBill';
import roomPrice from './roomPrice';
import operating from './operating';
import matchCalendar from './matchCalendar';

import clean from './clean';
import * as createReserve from './reservation/createReserve';
import * as reserveExchange from './reservation/reserveExchange';
import * as cancelReserve from './reservation/cancelReserve';
import * as checkIn from './reservation/checkIn';
import * as checkInByReserve from './reservation/checkInByReserve';
import * as checkInExchange from './reservation/checkInExchange';
import * as renewal from './reservation/renewal';
import * as checkOut from './reservation/checkOut';
import * as CRSReserveDetail from './reservation/reserveDetail4CRS';
import * as CRSReserveCreate from './reservation/reserveCreate4CRS';
import * as TodoTask from './todoTask';
import * as SystemAccount from './systemAccount';
import * as ReserveEditor from './reservation/reserveEditor';
import * as CheckInEditor from './reservation/checkInEditor';
import * as DirectRenewal from './reservation/directRenewal';
import * as GoodsReversal from './reversal/goods';
import wechatMomentEditor from './wechatMoment';

import shopProfile from './shopProfile';
import sopReport from './sopReport';

import * as invoice from './bill/invoice';

export default combineReducers({
  login,
  user,

  bill,
  credit,
  // partRefund,
  partSettle,
  preSettle,
  print,
  reverse,
  revSettle,
  // reverse,
  settle,
  transfer,
  refund,

  operating,

  computer,
  card,
  goods,
  inventory,
  stock,
  storeStorage,
  goodsManagement,
  record,
  goodsStock,
  peripheral,
  peripheralManagement,
  peripheralStock,

  meituanDirect,
  ctripDirect,
  changePriceApprove,
  dyDirect,

  staff,
  order,
  realtimeState,
  futureState,
  guest,
  transaction,
  channel,
  price,
  promotion,
  priceCalendar,

  handover,
  reports,
  otaBill,
  roomPrice,

  clean,
  matchCalendar,

  createReserve: createReserve.reducerMapper,
  reserveExchange: reserveExchange.reducerMapper,
  cancelReserve: cancelReserve.reducerMapper,
  checkIn: checkIn.reducerMapper,
  checkInByReserve: checkInByReserve.reducerMapper,
  checkInExchange: checkInExchange.reducerMapper,
  renewal: renewal.reducerMapper,
  checkOut: checkOut.reducerMapper,
  reserveDetail4CRS: CRSReserveDetail.reducerMapper,
  reserveCreate4CRS: CRSReserveCreate.reducerMapper,
  todoTask: TodoTask.reducerMapper,
  systemAccountManagement: SystemAccount.reducerMapper,
  reserveEditor: ReserveEditor.reducerMapper,
  checkInEditor: CheckInEditor.reducerMapper,
  directRenewal: DirectRenewal.reducerMapper,
  goodsReversal: GoodsReversal.reducerMapper,
  wechatMomentEditor,
  shopProfile,
  storeInfo,
  roomType,
  sopReport,

  invoice: invoice.reducerMapper,
});
